import React, { useState, useEffect, } from 'react'
import HtmlParser from 'react-html-parser';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';

import $ from 'jquery';

import 'react-tempusdominus-bootstrap';

import axios from 'axios';

import Menu from '../main/Menu';
import PurchaseConceptEdit from './PurchaseConceptEdit';
import {
    purchasePaymentDataGetAsync, purchaseStatusGet, purchaseTaxesGetAsync
} from '../../controllers/purchases/purchases';
import {
    checkIfUserIsMaster, dataTableLanguaje, responseGet, globalSettings, styles, separatorsNumbersSet, sendMessageCloseCurrentWindowAsync, dateTimeFormatGlobalSet, numberSet, buttonProcessGet,
    awaitDelay, processEvaluateGet, languageObjGet, isUndNullEmp, LoadingSection,
} from '../../helpers/settings';
import useAuth from '../../controllers/users/useAuth';
import PurchaseFiles from './PurchaseFiles';
import BuildingHeader from '../buildings/BuildingHeader';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { buildingModelGet } from '../../models/buildings/building';
import { purchaseDetailModelGet, purchaseModelGet } from '../../models/expenses/purchase';
import { supplierModelGet } from '../../models/expenses/suppliers';
import { taxModelGet } from '../../models/taxes/tax';

const currentMethod = 'PurchaseDetail';

export default function PurchaseDetail({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let headerObj = {};
    const { id, } = useParams();
    const auth = useAuth();
    //const history = useHistory();
    const neutralValue = 0.00;
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
    const [showView, setShowView] = useState(false);
    const [processType, setProcessType] = useState(0);
    const [showLoading, setShowLoading] = useState({ building: true, purchase: true, purchaseDetail: true, });
    const [isEditDelete, setIsEditDelete] = useState(false);
    //#endregion variables

    //#region building
    const [building, setBuilding] = useState(buildingModelGet({}));
    //#endregion building

    //#region purchase
    //let purchaseTwo = {};
    //const [purchaseDate, setPurchaseDate] = useState('');
    const [purchase, setPurchase] = useState(purchaseModelGet({}));
    //#endregion purchase

    //#region purchase details
    const dtPurchaseDetailsId = 'dtPurchaseDetails';
    const [purchaseDetails, setPurchaseDetails] = useState([]);
    const [dtPurchaseDetailsRowIndex, setDtPurchaseDetailsRowIndex] = useState(0);
    //#endregion purchase details

    //#region suppliers
    const chkSupplierNationalId = 'chkSupplierNational';
    const [suppliers, setSuppliers] = useState([supplierModelGet({})]);
    //#endregion suppliers

    //#region purchase detail
    let purchaseDetailsTwo = [];
    const [purchaseDetailEditShowModal, setPurchaseDetailEditShowModal] = useState(false);
    const [purchaseDetail, setPurchaseDetail] = useState({ expenseConceptId: '', description: '', rowIndex: 0, processType: 0, });
    //#endregion purchase detail

    //#region taxes
    const [taxes, setTaxes] = useState([taxModelGet({})]);
    //#endregion taxes

    //#region attachment
    const [btnAttachmentDisabled, setBtnAttachmentDisabled] = useState(true);
    const [filesShowModal, setFilesShowModal] = useState(false);
    //#endregion attachment

    //#region others
    const controls = {
        buttons: {
            edit: {
                id: 'btnEdit',
                className: 'btn btn-outline-warning',
            },
            attachment: {
                id: 'btnAttachment',
                className: 'btn btn-outline-info mx-1',
            },
            payments: {
                id: 'btnPayments',
                className: 'btn btn-outline-secondary',
            },
            back: {
                id: 'btnBack',
                className: 'btn btn-outline-success mx-1',
            },
            conceptEdit: {
                id: 'btnConceptEdit',
                className: 'btn btn-sm btn-outline-warning float-right',
            }
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            purchaseDetails: {
                buttons: {
                    // create: {
                    //     className: 'btn btn-outline-success float-right btn-sm mx-1',
                    //     id: 'btnDtSuppliersCreate',
                    // },
                },
                icons: {
                    // create: {
                    //     id: 'iconDtSuppliersCreate',
                    //     className: globalSettings?.icons?.plusCircle,
                    // },
                },
                inputs: {
                    search: {
                        id: `${dtPurchaseDetailsId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtPurchaseDetailsId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    // create: {
                    //     id: 'spDtSuppliersCreate',
                    //     className: '',
                    // },
                },
            },
        },
        icons: {
            edit: {
                id: 'icoEdit',
                className: globalSettings?.icons?.edit,
            },
            attachment: {
                id: 'icoAttachment',
                className: globalSettings?.icons?.paperClip,
            },
            payments: {
                id: 'icoPayments',
                className: globalSettings?.icons?.handHoldingUsd,
            },
            back: {
                id: 'icoBack',
                className: globalSettings?.icons?.arrowCircleLeft,
            },
            conceptEdit: {
                id: 'icoConceptEdit',
                className: globalSettings?.icons?.edit,
            },
        },
        inputs: {
            // user: {
            //     id: 'inputUser',
            //     className: 'form-control bg-transparent',
            // },
            // title: {
            //     id: 'inputTitle',
            //     className: 'form-control bg-transparent',
            // },
            // comment: {
            //     id: 'inputComment',
            //     className: 'form-control',
            // },
            // statusComment: {
            //     id: 'inputStatusComment',
            //     className: 'form-control bg-transparent text-black',
            // },
        },
        selects: {
            // apartment: {
            //     id: 'selApartmet',
            //     className: 'form-select',
            // },
            // title: {
            //     id: 'selTitle',
            //     className: 'form-select',
            // },
            // icon: {
            //     id: 'selIcon',
            //     className: 'form-select',
            // },
            // status: {
            //     id: 'selStatus',
            //     className: 'form-select',
            // },
        },
        spinners: {
            edit: {
                id: 'spEdit',
                className: '',
            },
            attachment: {
                id: 'spAttachment',
                className: '',
            },
            payments: {
                id: 'spPayments',
                className: '',
            },
            back: {
                id: 'spBack',
                className: '',
            },
            conceptEdit: {
                id: 'spConceptEdit',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region purchase (methods)
    const purchaseGoToAsync = async ({ e = {}, processType = 0, subMethod = '', }) => {
        const currentMethod = 'purchaseGoToAsync';
        let response = responseGet();
        try {
            //#region variables
            const processType_ = processType === -1 ?
                4 :
                processType === 1 ?
                    1 : 3;
            //#endregion variables

            controlsStatusSet({ processType: processType_, subMethod: currentMethod });

            //#region methods
            switch (processType) {
                case -1:
                    await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                    window.location.href = `${globalSettings?.app?.backend?.urlPurchases}`;
                    break;
                case 1:
                    await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                    window.location.href = `${globalSettings?.app?.backend?.urlPurchaseEdit}/${purchase?.id}`;
                    break;
                case 3:
                    //#region payment data check
                    response = await paymentDataGetAsync({ buildingId: purchase?.buildingId, subMethod: currentMethod, });

                    if (!response?.isSuccess || response?.isWarning) {
                        controlsStatusSet({ processType: 0, subMethod: currentMethod });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }
                    //#endregion payment data check

                    window.location.href = `${globalSettings?.app?.backend?.urlPurchasePayments}/${purchase?.id}`;
                    break;
                default:
                    break;
            }
            //#endregion methods

            controlsStatusSet({ processType: 0, subMethod: currentMethod });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const paymentDataGetAsync = async ({ buildingId = '', subMethod = '', }) => {
        const currentMethod = 'paymentDataGetAsync';
        let response = responseGet();
        try {
            response = await purchasePaymentDataGetAsync({
                buildingId: buildingId,
                limit: 0,
                valueReturn: false,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion purchase (methods)

    //#region methods (purchase details)
    const dataTablePurchaseDetailSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataTablePurchaseDetailSetAsync';
        let response = responseGet();
        try {
            $(`#${dtPurchaseDetailsId}`)?.DataTable({
                //buttons: ['excel', 'pdf', 'print', 'colvis',],
                autoWidth: false,
                columns: [
                    { title: globalSettings?.labels?.concept?.[languageObj?.id], width: '40%', orderable: false, },
                    { title: globalSettings?.labels?.quantity?.[languageObj?.id], className: 'text-right', orderable: false, width: '10%', },
                    { title: globalSettings?.labels?.price?.[languageObj?.id], className: 'text-right', orderData: false, width: '20%', },
                    { title: `${globalSettings?.labels?.taxAbbreviated?.[languageObj?.id]} %`, className: 'text-right', orderData: false, width: '10%', },
                    { title: globalSettings?.labels?.subTotal?.[languageObj?.id], className: 'text-right', orderable: false, width: '15%', },
                    { title: globalSettings?.labels?.process?.[languageObj?.id], className: 'text-center', orderable: false, searchable: false, width: '5%', },
                ],
                data: [],
                destroy: true,
                info: false,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                order: [[0, 'asc'],],
                responsive: true,
                lengthChange: true,
                ordering: true,
                paging: false,
                searching: false,
                //}).buttons().container().appendTo(`#${dtPurchaseDetailsId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion methods (purchase details)

    //#region concepts (methods)
    const conceptsEditGetAsync = async ({ id = '', description = '', rowIndex = 0, processType = 0, subMethod = '' }) => {
        const currentMethod = 'conceptsEditGetAsync';
        let response = responseGet();
        try {
            setProcessType(processType);
            setDtPurchaseDetailsRowIndex(rowIndex);
            setPurchaseDetail({ expenseConceptId: id, description: description, rowIndex: rowIndex, processType: processType, });
            $(`#${controls?.buttons?.conceptEdit?.id}`)?.trigger('click');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const conceptsEditPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'conceptsEditPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let purchaseDetailLocal = purchaseDetailModelGet({});
            //#endregion Variabls

            //#region process
            if (showView || processType === 2) {
                setShowLoading({ building: false, purchase: false, purchaseDetail: true, });

                //#region taxes get
                setTaxes([]);

                response = await purchaseTaxesGetAsync({
                    buildingId: purchase?.buildingId,
                    auth: auth,
                    languageId: languageObj?.id,
                    subMethod: currentMethod
                });

                if (!response?.isSuccess || response?.isWarning) {
                    setShowLoading({ building: false, purchase: false, purchaseDetail: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                setTaxes(response.result);
                //#endregion taxes get

                //#region purchase detail get
                purchaseDetailLocal = purchaseDetails?.find(({ expenseConceptId, }) => expenseConceptId === purchaseDetail?.expenseConceptId);
                if (isUndNullEmp({ data: purchaseDetailLocal, subMethod: currentMethod, })?.result) {
                    purchaseDetailLocal = purchaseDetails.find(({ id, }) => id === purchaseDetail?.expenseConceptId);
                }

                setPurchaseDetail(purchaseDetailLocal);
                //#endregion purchase detail get

                setPurchaseDetailEditShowModal(true);
                setShowLoading({ building: false, purchase: false, purchaseDetail: false, });
            }
            //#endregion process
        } catch (ex) {
            setShowLoading({ building: false, purchase: false, purchaseDetail: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion concepts (methods)

    //#region attachment files (methods)
    const attachmentFilesAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'attachmentFilesAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            controlsStatusSet({ processType: 2, subMethod: currentMethod, });
            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });

            setFilesShowModal(true);
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion attachment files (methods)

    //#region methods (others)
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ building: true, purchase: true, purchaseDetail: true, });

            //#region variables
            //let subTotalLocal = 0.00;
            let isEditLocal = false;
            let isDeleteLocal = false;
            let isEdiableLocal = false;
            let purchaseDetailsLocal = [];
            let purchaseDetailsThreeLocal = [];
            let purchaseLocal = purchaseModelGet({});
            let buildingLocal = buildingModelGet({});
            let suppliersLocal = [supplierModelGet({})];
            //#endregion variables

            //#region initialize
            setSuppliers([]);
            //purchaseTwo = {};
            setPurchase({});
            setBuilding({});
            setShowView(false);
            //setPurchaseDate('');
            setPurchaseDetails([]);
            purchaseDetailsTwo = [];
            //#endregion initialize

            //#region dataTable set
            response = await dataTablesSetAsync({ subMethod: currentMethod, });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, purchase: false, purchaseDetail: false, });
                return
            }
            //#endregion dataTable set

            //#region data get

            //#region purchase get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlPurchases}/${id}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, purchase: false, purchaseDetail: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            purchaseLocal = response?.result?.purchase;
            //purchaseTwo = localPurchase;
            setPurchase(purchaseLocal);
            //setPurchaseDate(dateTimeFormatGlobalSet(purchaseLocal.date, globalSettings?.react?.tempusDominus?.format?.date?.dmy, 0, false).result);

            isEdiableLocal = (purchaseLocal?.balance === purchaseLocal?.total) && purchaseLocal?.status === 1;

            //#region check if editr / delete
            isEditLocal = processEvaluateGet({
                object: purchaseLocal,
                property: globalSettings?.labels?.process?.en?.toLowerCase(),
                process: globalSettings?.labels?.edit?.en?.toLowerCase(),
                subMethod: currentMethod,
            })?.result;
            isDeleteLocal = isEditLocal;

            setIsEditDelete(!(isEditLocal && isDeleteLocal));
            //#endregion check if editr / delete
            //#endregion purchase get

            //#region purchase get (details)
            purchaseDetailsLocal = response?.result?.details;
            if (!isUndNullEmp({ data: purchaseDetailsLocal, subMethod: currentMethod, })?.result && purchaseDetailsLocal?.length > 0) {
                purchaseDetailsThreeLocal = [];
                purchaseDetailsLocal?.forEach((detail) => {
                    //#region variables
                    const subTotalObj = {
                        number: numberSet({
                            number: detail?.quantity,
                            type: 'd',
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result *
                            numberSet({
                                number: detail?.price,
                                type: 'd',
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            })?.result,
                        value: 0.00,
                    };

                    subTotalObj.value = numberSet({
                        number: subTotalObj?.number,
                        type: 'd',
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result;

                    const separatorNumbersObj = {
                        quantity: separatorsNumbersSet({
                            number: detail?.quantity,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                        price: separatorsNumbersSet({
                            number: detail?.price,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                        taxPercentage: separatorsNumbersSet({
                            number: detail?.taxPercentage,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                        subTotal: separatorsNumbersSet({
                            number: subTotalObj?.value,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                    }
                    //#endregion variables

                    //#region methods
                    purchaseDetailsTwo.push([
                        detail?.expenseConcept?.description,
                        //separatorsNumbersSet(detail?.quantity).result,
                        //separatorsNumbersSet(detail?.price).result,
                        //separatorsNumbersSet(detail?.taxPercentage).result,
                        //separatorsNumbersSet(subTotal).result,
                        separatorNumbersObj?.quantity,
                        separatorNumbersObj?.price,
                        separatorNumbersObj?.taxPercentage,
                        separatorNumbersObj?.subTotal,
                        buttonProcessGet({
                            id: detail?.id,
                            description: detail?.expenseConcept?.description,
                            showDetails: true,
                            labelDetails: globalSettings?.labels?.detail?.[languageObj?.id],
                            enabledDetails: true,
                            showEdit: true,
                            labelEdit: globalSettings?.labels?.edit?.[languageObj?.id],
                            enabledEdit: false,
                            showDelete: true,
                            labelDelete: globalSettings?.labels?.delete?.[languageObj?.id],
                            enabledDelete: false,
                            processButtons: [],
                            subMethod: currentMethod,
                        })?.result,
                    ]);

                    purchaseDetailsThreeLocal.push({
                        id: detail?.id,
                        //description: localConcept,
                        description: detail?.expenseConcept.description,
                        expenseConceptId: detail?.expenseConceptId,
                        price: detail?.price,
                        purchaseId: detail?.purchaseId,
                        quantity: detail?.quantity,
                        remark: detail?.remark,
                        taxId: detail?.taxId,
                        taxPercentage: detail?.taxPercentage,
                    });
                    //#endregion methods
                });
                setPurchaseDetails(purchaseDetailsThreeLocal);
            }
            //#endregion purchase get (details)

            //#region building get
            buildingLocal = response?.result?.building;
            setBuilding(buildingLocal);
            //#endregion building get

            //#region suppliers get
            suppliersLocal = response?.result?.suppliers;
            setSuppliers(suppliersLocal);
            //#endregion suppliers get
            //#endregion data get

            //#region check if editable or not
            setShowView(isEdiableLocal);
            //#endregion check if editable or not

            //#region dataTable set / set data in datatable
            $(`#${dtPurchaseDetailsId}`)?.DataTable()?.rows?.add(purchaseDetailsTwo)?.draw(true);
            //#endregion dataTable set / set data in datatable

            setShowLoading({ building: false, purchase: false, purchaseDetail: false, });
        } catch (ex) {
            setShowLoading({ building: false, purchase: false, purchaseDetail: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataTablesSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = '';
        let response = responseGet();
        try {
            setBtnAttachmentDisabled(false);

            //#region dataTables set
            response = await dataTablePurchaseDetailSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion dataTables set

            //#region query set
            response = await queryCodeSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion query set
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const queryCodeSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSetAsync';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region methods
            $(`#${dtPurchaseDetailsId} tbody`)?.on('click', 'tr', 'td', function (e) {
                e.preventDefault();
                rowIndex = $(`#${dtPurchaseDetailsId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value;
                    method = e?.target?.attributes?.method?.value;
                    description = e?.target?.attributes?.description?.value;
                    switch (method) {
                        // case 'edit':
                        //     conceptsEditGetAsync(localId, description, dtRowIndex, 1);
                        //     break;
                        case 'details':
                            conceptsEditGetAsync({ id: id, description: description, rowIndex: dtRowIndex, processType: 2, subMethod: currentMethod, });
                            break;
                        // case 'delete':
                        //     localConceptDeleteGet(localId, description, dtRowIndex);
                        //     break;
                        default:
                            break;
                    }
                }
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.edit?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.edit?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.attachment?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.attachment?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 3:
                    $(`#${controls?.icons?.payments?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.payments?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 4:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            //$(`#${controls?.inputs?.quantity?.id}`)?.attr('readOnly', (processType !== 0));
            //$(`#${controls?.inputs?.price?.id}`)?.attr('readOnly', (processType !== 0));
            //#endregion controls

             //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

           //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

             //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            $(`#${controls?.dataTables?.purchaseDetails?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.purchaseDetails?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.edit?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.attachment?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.payments?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, []) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='expenses' process='purchases' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{globalSettings?.labels?.purchases?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{globalSettings?.labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item'><Link to={globalSettings?.app?.backend?.urlPurchases}>{globalSettings?.labels?.purchases?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{globalSettings?.labels?.detail?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        {/*buildings*/}
                        <BuildingHeader buildingsId={''}
                            building={building}
                            buildings={[]}
                            btnSyncDisabled={''}
                            methodGetAsync={null}
                            processType={1}
                            headerSectionValues={{}}
                            showLoading={showLoading?.building}
                            languageObj={languageObj} />

                        {/*purchase*/}
                        <div className='row'>
                            <div className='col-12'>
                                <form>
                                    <div className='card card-outline card-primary shadow' >
                                        <LoadingSection alt='loadingSection'
                                            className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                            showText={true}
                                            text={globalSettings?.messages?.processing?.[languageObj?.id]}
                                            height={25}
                                            hidden={!showLoading?.purchase}
                                            width={25}
                                            languageId={languageObj?.id}
                                            subMethod={currentMethod} />

                                        <div className='card-header'>
                                            <h6 className='card-title'>
                                                <img alt={globalSettings?.labels?.purchase?.[languageObj?.id]} src={globalSettings?.images?.invoiceLogo} style={styles?.cardHeaderLogo}></img> - {globalSettings?.labels?.purchase?.[languageObj?.id]}
                                            </h6>
                                            <div className='card-tools'>
                                                <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                    <i className={globalSettings?.icons?.minus}></i>
                                                </button>
                                            </div>
                                        </div>

                                        <div className='card-body'>
                                            <div className='row text-muted'>
                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <i className={globalSettings?.icons?.sortNumericUpAlt}></i>{
                                                            HtmlParser(`   ${globalSettings?.labels?.number?.[languageObj?.id]}: <b>${purchase?.number || 0}</b>`)
                                                        }
                                                    </div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <i className={globalSettings?.icons?.toggleOn}></i>
                                                        {purchaseStatusGet({
                                                            purchase: purchase,
                                                            showStateLabel: true,
                                                            htmlParser: true,
                                                            languageId: languageObj?.id,
                                                            subMethod: 'lbl - purchaseStatus',
                                                        })?.result}
                                                    </div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        {/* <i className={globalSettings?.icons?.calendarAlt}></i>{HtmlParser(`   ${globalSettings?.labels?.date?.[languageObj?.id]}: <b>${!isUndefined(purchaseDate) ? purchaseDate : ''}</b>`)} */}
                                                        <i className={globalSettings?.icons?.calendarAlt}></i>{
                                                            HtmlParser(`   ${globalSettings?.labels?.date?.[languageObj?.id]}: <b>${dateTimeFormatGlobalSet({
                                                                date: purchase?.date || new Date(),
                                                                type: languageObj?.format?.date?.f1,
                                                                format: 0,
                                                                addTime: false,
                                                                secondsShow: false,
                                                                languageId: languageObj?.id,
                                                                subMethod: 'lbl - purchaseDate',
                                                            })?.result}</b>`)
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row text-muted'>
                                                <div className='col-md-8'>
                                                    <div className='form-group'>
                                                        <span className={globalSettings?.icons?.userTag}></span>{
                                                            HtmlParser(`   ${globalSettings?.labels?.supplier?.[languageObj?.id]}: <b>${suppliers?.filter(({ id }) => id === purchase?.supplierId || '')?.[0]?.description || ''}</b>`)
                                                        }
                                                    </div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <div className='form-group text-muted'>
                                                        {/* <div className='input-group'> */}
                                                        <div className='icheck-primary d-inline'>
                                                            <input
                                                                checked={suppliers?.filter(({ id }) => id === purchase?.supplierId || '')?.[0]?.national || false}
                                                                id={chkSupplierNationalId}
                                                                //onChange={(e) => setPurchase({...purchase, national: e.target.checked,})}
                                                                readOnly
                                                                tooltip='tooltip'
                                                                title={globalSettings?.labels?.isNational?.[languageObj?.id]}
                                                                type='checkbox' />
                                                            <label htmlFor={chkSupplierNationalId}
                                                                tooltip='tooltip'
                                                                title={globalSettings?.labels?.isNational?.[languageObj?.id]}>{globalSettings?.labels?.isNational?.[languageObj?.id]}?
                                                            </label>
                                                        </div>
                                                        {/* </div> */}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row text-muted'>
                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <span className={globalSettings?.icons?.sortNumericUpAlt}></span>{
                                                            HtmlParser(`   ${globalSettings?.labels?.invoiceNumber?.[languageObj?.id]} (${globalSettings?.labels?.supplier?.[languageObj?.id]}): <b>${purchase?.invoiceNumber || ''}</b>`)
                                                        }
                                                    </div>
                                                </div>
                                                <div className='col-md-4'>

                                                </div>
                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <span className={globalSettings?.icons?.fileContract}></span>{
                                                            HtmlParser(`   ${globalSettings?.labels?.controlNumber?.[languageObj?.id]} (${globalSettings?.labels?.supplier?.[languageObj?.id]}): <b>${purchase?.invoiceControlNumber || ''}</b>`)
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row text-muted'>
                                                <div className='col-md-12'>
                                                    <div className='form-group'>
                                                        <span className={globalSettings?.icons?.fasFa?.tag}></span>{
                                                            HtmlParser(`   ${globalSettings?.labels?.remark?.[languageObj?.id]} : <b>${purchase?.description?.replaceAll('\n', '<br/>') || ''}</b>`)
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='card-footer'>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        {/*purchase (details)*/}
                        <div className='row'>
                            <div className='col-12'>
                                <form>
                                    <div className='card card-outline card-primary shadow' >
                                        <LoadingSection alt='loadingSection'
                                            className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                            showText={true}
                                            text={globalSettings?.messages?.processing?.[languageObj?.id]}
                                            height={25}
                                            hidden={!showLoading?.purchaseDetail}
                                            width={25}
                                            languageId={languageObj?.id}
                                            subMethod={currentMethod} />

                                        <div className='card-header'>
                                            <h6 className='card-title'>
                                                <img alt={globalSettings?.labels?.purchase?.[languageObj?.id]} src={globalSettings?.images?.shoppingCart} style={styles?.cardHeaderLogo}></img> - {globalSettings?.labels?.purchase?.[languageObj?.id]} ({globalSettings?.labels?.detail?.[languageObj?.id]?.toLowerCase()})
                                            </h6>
                                            <div className='card-tools'>
                                                <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                    <i className={globalSettings?.icons?.minus}></i>
                                                </button>
                                            </div>
                                        </div>

                                        <div className='card-body'>
                                            <div className='row'>
                                                <div className='col-md-12 text-muted'>

                                                    <b>{globalSettings?.labels?.details?.[languageObj?.id]}</b>

                                                    <button id={controls?.buttons?.conceptEdit?.id}
                                                        className={controls?.buttons?.conceptEdit?.className}
                                                        hidden={true}
                                                        onClick={(e) => conceptsEditPostAsync(e)}
                                                        tooltip='tooltip'
                                                        title={globalSettings?.labels?.edit?.[languageObj?.id]}
                                                        type='button'>
                                                        <i id={controls?.icons?.conceptEdit?.id} className={controls?.icons?.conceptEdit?.className} /> <span id={controls?.spinners?.conceptEdit?.id} className='' aria-hidden='true'></span>
                                                    </button>

                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                        <table id={dtPurchaseDetailsId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-md-6'>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='table-responsive'>
                                                        <table className='table table-sm'>
                                                            <tbody>
                                                                <tr>
                                                                    <th style={{ width: '50%' }}>{globalSettings?.labels?.subTotal?.[languageObj?.id]}:</th>
                                                                    <td className='text-right'>{
                                                                        separatorsNumbersSet({
                                                                            number: purchase?.subTotal || neutralValue,
                                                                            withDecimals: true,
                                                                            consoleLogErrorShow: true,
                                                                            subMethod: 'lbl - purchaseSubTotal',
                                                                        })?.result
                                                                    }</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>{globalSettings?.labels?.taxBase?.[languageObj?.id]}:</th>
                                                                    <td className='text-right'>{
                                                                        //separatorsNumbersSet(!isUndefined(purchase.taxBase) ? purchase.taxBase : neutralValue).result
                                                                        separatorsNumbersSet({
                                                                            number: purchase?.taxBase || neutralValue,
                                                                            withDecimals: true,
                                                                            consoleLogErrorShow: true,
                                                                            subMethod: 'lbl - purchaseTaxBase',
                                                                        })?.result
                                                                    }</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>{globalSettings?.labels?.exemptAmount?.[languageObj?.id]}:</th>
                                                                    <td className='text-right'>{
                                                                        //separatorsNumbersSet(!isUndefined(purchase.exemptAmount) ? purchase.exemptAmount : neutralValue).result
                                                                        separatorsNumbersSet({
                                                                            number: purchase?.exemptAmount || neutralValue,
                                                                            withDecimals: true,
                                                                            consoleLogErrorShow: true,
                                                                            subMethod: 'lbl - purchaseExemptAmount',
                                                                        })?.result
                                                                    }</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>{globalSettings?.labels?.tax?.[languageObj?.id]} ({
                                                                        //separatorsNumbersSet(!isUndefined(purchase.taxPercentage) ? purchase.taxPercentage : neutralValue).result
                                                                        separatorsNumbersSet({
                                                                            number: purchase?.taxPercentage || neutralValue,
                                                                            withDecimals: true,
                                                                            consoleLogErrorShow: true,
                                                                            subMethod: 'lbl - purchaseTaxPercentage',
                                                                        })?.result
                                                                    } %):</th>
                                                                    <td className='text-right'>{
                                                                        //separatorsNumbersSet(!isUndefined(purchase.taxAmount) ? purchase.taxAmount : neutralValue).result
                                                                        separatorsNumbersSet({
                                                                            number: purchase?.taxAmount || neutralValue,
                                                                            withDecimals: true,
                                                                            consoleLogErrorShow: true,
                                                                            subMethod: 'lbl - purchaseTaxAmount',
                                                                        })?.result
                                                                    }</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>{globalSettings?.labels?.total?.[languageObj?.id]}:</th>
                                                                    <td className='text-right'>{
                                                                        //separatorsNumbersSet(!isUndefined(purchase.total) ? purchase.total : neutralValue).result
                                                                        separatorsNumbersSet({
                                                                            number: purchase?.total || neutralValue,
                                                                            withDecimals: true,
                                                                            consoleLogErrorShow: true,
                                                                            subMethod: 'lbl - purchaseTotal',
                                                                        })?.result
                                                                    }</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>{globalSettings?.labels?.balance?.[languageObj?.id]}:</th>
                                                                    <td className='text-right'>{
                                                                        //separatorsNumbersSet(!isUndefined(purchase.balance) ? purchase.balance : neutralValue).result
                                                                        separatorsNumbersSet({
                                                                            number: purchase?.balance || neutralValue,
                                                                            withDecimals: true,
                                                                            consoleLogErrorShow: true,
                                                                            subMethod: 'lbl - purchaseBalance',
                                                                        })?.result
                                                                    }</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='card-footer'>
                                            <div className='form-group text-right'>
                                                <button id={controls?.buttons?.edit?.id}
                                                    className={controls?.buttons?.edit?.className}
                                                    disabled={isEditDelete}
                                                    onClick={(e) => purchaseGoToAsync({ e: e, processType: 1, subMethod: 'btn - purchaseEdit', })}
                                                    tooltip='tooltip'
                                                    title={globalSettings?.labels?.edit?.[languageObj?.id]} type='button'>
                                                    <i id={controls?.icons?.edit?.id} className={controls?.icons?.edit?.className} /> <span id={controls?.spinners?.edit?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <button id={controls?.buttons?.attachment?.id}
                                                    className={controls?.buttons?.attachment?.className}
                                                    disabled={btnAttachmentDisabled}
                                                    onClick={(e) => attachmentFilesAsync({ e: e, subMethod: 'form - btnAttachment', })}
                                                    tooltip='tooltip' title={globalSettings?.labels?.toAttach?.[languageObj?.id]}
                                                    type='button'>
                                                    <i id={controls?.icons?.attachment?.id} className={controls?.icons?.attachment?.className} /> <span id={controls?.spinners?.attachment?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <button id={controls?.buttons?.payments?.id}
                                                    className={controls?.buttons?.payments?.className}
                                                    onClick={(e) => purchaseGoToAsync({ e: e, processType: 3, subMethod: 'btn - purchasePayments', })}
                                                    tooltip='tooltip'
                                                    title={globalSettings?.labels?.payments?.[languageObj?.id]}
                                                    type='button'>
                                                    <i id={controls?.icons?.payments?.id} className={controls?.icons?.payments?.className} /> <span id={controls?.spinners?.payments?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <button id={controls?.buttons?.back?.id}
                                                    className={controls?.buttons?.back?.className}
                                                    onClick={(e) => purchaseGoToAsync({ e: e, processType: -1, subMethod: 'btn - purchaseBack', })}
                                                    tooltip='tooltip'
                                                    title={globalSettings?.labels?.back?.[languageObj?.id]}
                                                    type='button'>
                                                    <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                {/* <Link className='btn btn-outline-success mx-1'
                                                    tooltip='tooltip'
                                                    title={globalSettings?.labels?.back?.[languageObj?.id]}
                                                    to={globalSettings?.app?.backend?.urlPurchases}>
                                                    <i className={globalSettings?.icons?.arrowCircleLeft}></i>
                                                </Link> */}
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                    </div>
                </section>

            </div>

            {purchaseDetailEditShowModal ?
                <PurchaseConceptEdit $={$}
                    auth={auth}
                    purchase={purchase}
                    setPurchase={setPurchase}
                    purchaseDetail={purchaseDetail}
                    setPurchaseDetail={setPurchaseDetail}
                    purchaseDetails={purchaseDetails}
                    setPurchaseDetails={setPurchaseDetails}
                    dtId={dtPurchaseDetailsId}
                    rowIndex={dtPurchaseDetailsRowIndex}
                    taxes={taxes}
                    showModal={purchaseDetailEditShowModal}
                    setShowModal={setPurchaseDetailEditShowModal}
                    processType={processType}
                    languageObj={languageObj} />
                :
                <></>
            }

            {filesShowModal ?
                <PurchaseFiles $={$}
                    auth={auth}
                    userRole={userRole}
                    showModal={filesShowModal}
                    setShowModal={setFilesShowModal}
                    purchase={purchase}
                    setPurchase={setPurchase}
                    languageObj={languageObj} />
                :
                <></>
            }

        </div>
    )
}